export default "__VITE_ASSET__BSeRosQH__"